import $ from 'jquery';

'use strict';

var currentInnerWidth = 0;
var currentDevice = '';
var ticking = false;

var device_dimensions = {
    width: {
        desktop: 1440,
		desktop_small: 1280, //1025, //1280, //1025,
        tablet: 992,
        tablet_portrait: 768,
    }
};
function checkViewport(innerWidth) {
    const deviceForWidth = deviceForSize(innerWidth);

    if (deviceForWidth !== currentDevice) {
        currentDevice = deviceForWidth;
        $(document).trigger('pub:viewport', [currentDevice]);
    }
}

function deviceForSize(width) {
    if (width < device_dimensions.width.tablet_portrait) {
        return 'mobile';
    } else if (width < device_dimensions.width.tablet) {
        return 'tablet portrait';
    } else if (width < device_dimensions.width.desktop_small) {
		return 'tablet landscape';
	} else if (width < device_dimensions.width.desktop) {
        return 'desktop small';
        // return 'tablet landscape';
	} else {
        return 'desktop';
    }
}

function observeViewport() {
    window.addEventListener('resize', function (e) {
        currentInnerWidth = window.innerWidth;
        if (!ticking) {
            window.requestAnimationFrame(function () {
                checkViewport(currentInnerWidth);
                ticking = false;
            });
            ticking = true;
        }
    });
    currentInnerWidth = window.innerWidth;
    $(document).trigger('pub:viewport', [deviceForSize(currentInnerWidth)]);
}
export default observeViewport;

